import type { BuildFlow } from '../types'

export const buildFlow: BuildFlow = props => props
